import { Grid, MenuItem, Stack, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStatisticsThunk } from "store/reducers/statistics/statisticsSlice";
import SalesStatistics from "./SalesStatistics";
import StockStatistics from "./StockStatistics";
import TopSellingProducts from "./TopSellingProducts";
import TopPerformingMachines from "./TopPerformingMachines";
import PerformanceAnalysis from "./PerformanceAnalysis";
import { getMinMachinesThunk } from "store/reducers/vending";
import AutoCompleteList from "components/AutoCompleteList";

const Statistics = () => {
  const dispatch = useDispatch();

  const machines = useSelector((state) => state.vending.minMachines);
  const [filter, setFilter] = React.useState({
    time: "all",
    machine: null,
  });

  useEffect(() => {
    dispatch(getStatisticsThunk(filter.machine?.id));
  }, [filter.machine]);

  useEffect(() => {
    dispatch(getMinMachinesThunk());
  }, []);

  return (
    <Stack direction="column" padding={2}>
      <Grid container spacing={1} sx={{ pr: 3 }}>
        <Grid item lg={4} md={6} xs={12}>
          <Stack alignItems="end" direction="row" spacing={2} marginBottom={2}>
            <TextField
              label="Filter by time"
              variant="outlined"
              select
              fullWidth
              value={filter.time}
              onChange={(e) => setFilter({ ...filter, time: e.target.value })}
              autoComplete="new-password"
            >
              <MenuItem value="all">All time</MenuItem>
              <MenuItem value="today">Today</MenuItem>
              <MenuItem value="week">This week</MenuItem>
              <MenuItem value="month">This month</MenuItem>
              <MenuItem value="year">This Year</MenuItem>
            </TextField>
            <AutoCompleteList
              items={machines}
              name="name"
              label="Filter by machine"
              setValue={(value) => {
                setFilter({
                  ...filter,
                  machine: value,
                });
              }}
              value={filter.machine}
            />
          </Stack>
        </Grid>
      </Grid>
      <SalesStatistics />
      <StockStatistics />
      <Grid container spacing={1} sx={{ pr: 3, mt: 4 }}>
        <Grid item lg={6} md={6} xs={12}>
          <TopSellingProducts time={filter.time} />
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
          <TopPerformingMachines time={filter.time} />
        </Grid>
      </Grid>

      <PerformanceAnalysis time={filter.time} />
    </Stack>
  );
};

export default Statistics;
